export default __webpack_public_path__ + "static/media/info_black.a2642f79.svg";